import { Orb } from "./Orb";
import { Screen } from "./Screen";
import { Body } from "./Text";

interface WorkingProps {
  readonly message: string;
}

/** A wait the person can see is a wait, with the orb breathing. */
export function Working({ message }: WorkingProps) {
  return (
    <Screen centred>
      <Orb size={96} floating />
      <Body className="mt-8" role="status" aria-live="polite">
        {message}
      </Body>
    </Screen>
  );
}
